import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

function AccountDetails({ data, onNext }) {
  const [formData, setFormData] = useState(data);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Account name is required';
    if (!formData.type) newErrors.type = 'Account type is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onNext({ accountDetails: formData });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        fullWidth
        label="Account Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        error={!!errors.name}
        helperText={errors.name}
        sx={{ mb: 3 }}
      />
      
      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Account Type</InputLabel>
        <Select
          name="type"
          value={formData.type}
          onChange={handleChange}
          error={!!errors.type}
        >
          <MenuItem value="business">Business</MenuItem>
          <MenuItem value="personal">Personal</MenuItem>
          <MenuItem value="nonprofit">Non-Profit</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}

export default AccountDetails; 